import { BettableButton } from './BettableButton'
import { BET_CHECKING_MODE, Phase } from '../Logic/Logic'
import { Constants } from '../Utils/Constants'
import { BetsDisplay } from './BetsDisplay'
import { Client } from '@core/Client'
import { deepCopy } from '@core/Utils/HelperFunction'

export class HotSpot extends Phaser.GameObjects.Polygon {
	public kavalWidth: number = 0;
	public kavalHeight: number = 0;
	public touchActive: boolean = false;
	public Center: Phaser.Math.Vector2;
	public hotSpotBetX: number;
	public hotSpotBetY: number;
	public offsetX: number = 0;
	public offsetY: number = 0;

	private buttonsList: Array<BettableButton>
	private effectsEnabled: boolean = true;
	private pointerDown: boolean = false;
	private betCheckingModes: Array<BET_CHECKING_MODE>;
	private betsDisplay: BetsDisplay;

	constructor(
			scene: Phaser.Scene,
			i: number,
			j: number,
			points: number[][],
			_offsetX?: number,
			_offsetY?: number,
			private _isTrack: boolean = false,
			private _checkTouch: boolean = false,
			_betCheckingModes?: Array<BET_CHECKING_MODE>,
			kavalSize = {
				width: 0,
				height: 0
			}) {

		super(scene, 0, 0, points, 0xFF5733);

		if (_isTrack) {
			this.fillAlpha = 0
			this.alpha = 1
		} else {
			this.alpha = 0
			this.setOrigin(0)
		}

		if (_checkTouch)
			this.betCheckingModes = deepCopy(_betCheckingModes);

		this.kavalWidth = kavalSize.width;
		this.kavalHeight = kavalSize.height;
		this.hotSpotBetX = i;
		this.hotSpotBetY = j;
		this.offsetX = _offsetX;
		this.offsetY = _offsetY;
		this.buttonsList = new Array()
		this.setInteractive(new Phaser.Geom.Polygon((points as any) as Phaser.Geom.Point[]), Phaser.Geom.Polygon.Contains);

		// Will receive input even if the object is invisible or not rendered
		this.input.alwaysEnabled = true
		this.setVisible(false)

		let center = new Phaser.Math.Vector2(0, 0)
		points.forEach(point => {
			center.x += point[0]
			center.y += point[1]
		});
		this.Center = new Phaser.Math.Vector2(center.x / points.length, center.y / points.length)

		if (this.hotSpotBetX != 27) { // if Tout Va bet field, it cannot be used by user
			this.on('pointerover', (p, x, y, e) => {
				if (!Client.logic.lockAnimations)
					this.SetButtonsHighlighted();
			}, this);
		}
		this.on("pointerout", (e) => { this.OnPointerOut(e) }, this);
		this.on("pointermove", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event) => { this.onPointerMove(pointer, localX, localY, event) }, this);
		this.on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event) => {
			this.onPointerDown(pointer, localX, localY, event)
			document.addEventListener('pointerup', () => {
				this.onPointerUp()
			}, { once: true }) // pointer up event for inside the document and outside
		}, this);
		//}
		// If pointer up is detected by Phaser then it fires this event (not necces)
		// this.scene.game.events.addListener(Constants.EVENTS.SCENE_GLOBAL_POINTER_UP_EVENT, this.onPointerUp, this)
	}

	get ButtonsList(): Array<BettableButton> {
		return this.buttonsList
	}

	AddButton(buttons: BettableButton[]): void {
		for (let i = 0; i < buttons.length; i++) {
			this.buttonsList.push(buttons[i])
		}
	}

	SetButtonsHighlighted(): void {
		if (Client.logic.BetsAllowed && this.effectsEnabled) {
			for (let i = 0; i < this.buttonsList.length; i++) {
				this.buttonsList[i].SetHighlighted()
			}
		}
	}

	OnPointerOut(e): void {
		let hotspotPos = { x: this.x, y: this.y }
		let pointerPos = { x: e.x, y: e.y }
		let hotspotSize = (this._isTrack) ? { width: this.displayWidth - this.kavalWidth, height: this.displayHeight - this.kavalHeight } : { width: this.displayWidth, height: this.displayHeight }

		this.touchActive = false;
		if (Client.logic.BetsAllowed && this.effectsEnabled)
			this.SetButtonsNormal();
	}

	SetButtonsNormal(): void {
		if (this.effectsEnabled) {
			for (let i = 0; i < this.buttonsList.length; i++) {
				this.buttonsList[i].SetNormal()
			}
		}
	}

	ToggleEffectsEnabled(enabled: boolean): void {
		this.effectsEnabled = enabled;
	}

	private onPointerUp(): void {
		this.betsDisplay.ToggleTouchPointer(false);
		this.touchActive = false;
		this.pointerDown = false;
	}

	private onPointerDown(e: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData): void {
		event.stopPropagation()
		if (!Client.logic.BetsAllowed) {
			this.notifyOnClick();
			return
		}
		this.pointerDown = true;
		this.touchActive = true;
		this.betsDisplay.ToggleTouchPointer(true);
		this.betsDisplay.SetStartingTouchPosition(e.x, e.y, this);
		
		if (Client.logic.paintModeEnabled) {
			this.notifyOnClick();
		}
		
		// Commented to prevent the infinite chip placement bug
		// this.StartInitialTouchTimeout();
	}

	private initialTimeoutLock: boolean = false;
	private touchTimeoutLock: boolean = false;
	StartInitialTouchTimeout(): void {
		if (!this.initialTimeoutLock) {
			this.initialTimeoutLock = true;
			setTimeout(() => {
				this.OnTouchDownTimeout();
			}, Constants.CHIP_PAINTING.TOUCH_DOWN.INITIAL_OFFSET);
		}
	}

	OnTouchDownTimeout(): void {
		if (this.touchActive /*&& this.scene.input.activePointer.isDown*/) {
			this.notifyOnClick();
			this.touchTimeoutLock = false;
			this.StartTouchDownTimeout();
		} else {
			this.initialTimeoutLock = false;
			this.touchTimeoutLock = false;
		}
	}

	StartTouchDownTimeout(): void {
		if (!this.touchTimeoutLock) {
			setTimeout(() => {
				this.OnTouchDownTimeout();
			}, Constants.CHIP_PAINTING.TOUCH_DOWN.OFFSET);
		}
	}

	private onPointerMove(e: Phaser.Input.Pointer, localX: number, localY: number, event): void {
		event.stopPropagation()
		if (this.betsDisplay.TouchActive && Client.logic.paintModeEnabled) {
			if (!this.touchActive) {
				this.betsDisplay.DoLinearInterpolation(e.x, e.y, this);
				this.notifyOnClick();
				this.touchActive = true;;
			}
		}
	}

	private notifyOnClick(): void {
		//if (this.hotSpotBetX == 27)
		//	return;

		if (Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY) {
			Client.logic.OnHistoryButtonClicked()
			return
		}
		Client.logic.PlaceBet(this.hotSpotBetX, this.hotSpotBetY)
	}

	get OffsetX(): number {
		return this.offsetX;
	}

	get OffsetY(): number {
		return this.offsetY;
	}

	SetBetsDisplay(betD: BetsDisplay): void {
		this.betsDisplay = betD;
	}
}